import PropTypes from 'prop-types';

const STATUS_CONFIG = {
	pending: { label: 'Ausstehend', bg: 'bg-bgBase-400', text: 'text-text' },
	generating_pdf: { label: 'Wird vorbereitet', bg: 'bg-bgBase-400', text: 'text-text' },
	pdf_ready: { label: 'Wird vorbereitet', bg: 'bg-bgBase-400', text: 'text-text' },
	processing: { label: 'In Bearbeitung', bg: 'bg-primary-200', text: 'text-primary-700' },
	needs_review: { label: 'Prüfung', bg: 'bg-caution-200', text: 'text-caution-700' },
	at_printer: {
		label: 'Im Druck',
		bg: 'bg-primary-200',
		text: 'text-primary-700',
		animate: true,
		dot: 'bg-primary-500',
	},
	printed: {
		label: 'Gedruckt',
		bg: 'bg-primary-200',
		text: 'text-primary-700',
		animate: true,
		dot: 'bg-primary-500',
	},
	sent: { label: 'Bei der Post', bg: 'bg-success-200', text: 'text-success-700' },
	returned: { label: 'Zurückgesendet', bg: 'bg-caution-200', text: 'text-caution-700' },
	failed: { label: 'Fehlgeschlagen', bg: 'bg-warning-200', text: 'text-warning-700' },
	cancelled: { label: 'Storniert', bg: 'bg-bgBase-400', text: 'text-bgBase-800' },
};

export default function PostMailingSendStatusBadge({ status }) {
	const config = STATUS_CONFIG[status] || STATUS_CONFIG.pending;

	return (
		<span
			className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium ${config.bg} ${config.text}`}
		>
			{config.animate && <span className={`w-1.5 h-1.5 rounded-full animate-pulse ${config.dot}`} />}
			{config.label}
		</span>
	);
}

PostMailingSendStatusBadge.propTypes = {
	status: PropTypes.string.isRequired,
};
